<template>
  <sweet-modal ref="loader" :blocking="true" :hide-close-button="true">
    <div class="loading-panel">
      <circle-loader :loading="loading" class="loading-icon" color="#00a09e" />
      <span class="loading-text">Loading...</span>
    </div>
  </sweet-modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      loading: state => state.loading
    })
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$refs.loader.open();
      } else {
        this.$refs.loader.close();
      }
    }
  }
};
</script>
<style scoped>
.loading-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.loading-icon {
  margin: 5px;
  align-self: center;
}

.loading-text {
  margin: 5px;
  align-self: center;
}

.sweet-modal-overlay >>> .sweet-modal {
  max-width: 230px;
  max-height: 240px;
}
.sweet-modal-overlay >>> .sweet-modal {
  background: rgba(255, 255, 255, 0.6);
}
.sweet-modal-overlay {
  background: rgba(0, 0, 0, 0.1);
}
</style>
